import React from 'react';

const IconCheckBullet = ({ color = '#F5841F', width = 22, height = 22 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5996 7.33936L9.93289 13.3394L6.59961 10.813"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.599609 10.6001C0.599609 16.1226 5.07711 20.6001 10.5996 20.6001C16.1221 20.6001 20.5996 16.1226 20.5996 10.6001C20.5996 5.0776 16.1221 0.600098 10.5996 0.600098C5.07711 0.600098 0.599609 5.0776 0.599609 10.6001Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconCheckBullet;
